// Session management sagas (logout)
import { put } from 'redux-saga/effects';

// Services
import { ErrorCategory, handleError } from '@services/errorService';
import { removeActiveSessionToken } from '@services/sessionToken';

// Api
import client from '@api';

// Actions
import { AccountLogout, AccountLogoutToLogin } from '@actions/account';
import { UserLogout } from '@actions/user';
import { SetRedirectControl } from '@actions/redirectControl';

import { REDIRECT_PATH } from './constants';

export function* logout(): Generator<unknown, void, unknown> {
  try {
    removeActiveSessionToken();
    localStorage.clear();
    yield client().clearStore();
    window.open('https://www.getmrbl.ai', '_self');
  } catch (error) {
    handleError(error, { category: ErrorCategory.AUTH });
  }
}

export function* logoutToLogin(): Generator<unknown, void, unknown> {
  try {
    removeActiveSessionToken();
    const version = localStorage.getItem('version');
    localStorage.clear();
    if (version) {
      localStorage.setItem('version', version);
    }
    yield client().clearStore();
    yield put(SetRedirectControl(`${REDIRECT_PATH.login}`));
  } catch (error) {
    handleError(error, { category: ErrorCategory.AUTH });
  }
}

// Action creators for watchers
export const sessionActions = {
  UserLogout,
  AccountLogout,
  AccountLogoutToLogin,
};
